export default {
    // Not sure it's used anywhere any more
    alert: function(title, content, succ){
        if(typeof content === 'undefined' || !content)
            alertify.alert("Alert", title);
        else
            alertify.alert(title, content, (typeof succ !== 'undefined' ? succ : null));
    },
    secondsToMMSS(t) {
        t = Math.round(t);

        var res = "00:00";
        if(t < 0)
            return res;
        var mins = Math.floor(t / 60).toString();
        var secs = (t % 60).toString();
        if (mins.length == 1)
            mins = "0" + mins;
        if (secs.length == 1)
            secs = "0" + secs;
        res = mins + ":" + secs;
        return res;
    },
    getItemLocation(item, size = "md") {
        if(!item?.type)
            return "";
        item.type = item.type.toUpperCase();

        // THIS SHOULD BE THE DEFAULT FROM NOW ON
        if(item.dir)
            return `/images/${item.dir}/${size}/${item.preview_loc}`;
        else if (item.type === 'COINS')
            return `/images/icons/${size}/coins.png`;
        else if (item.type === 'EVENT')
            return `/images/icons/${size}/event-token.png`;
        else if (item.type === 'DIAMOND' || item.item_id === 37)
            return `/images/icons/${size}/diamond.png`;
        else if (item.type === 'PAINTING')
            return `/images/paintings/${size}/${item.preview_loc}`;
        else if (item.type === 'CARPET')
            return `/images/carpets/${size}/${item.preview_loc}`;
        else if (item.type === "FURNITURE")
            return `/images/furniture/${item.category}/${size}/${item.preview_loc}`;
        else if (item.type === "GEM")
            return `/images/gems/${size}/${item.preview_loc}`;
        else if (item.type === "MASK")
            return `/images/face-masks/${size}/${item.preview_loc}`;
        else if (item.type === "HAT")
            return `/images/hats/${size}/${item.preview_loc}`;
        else if (item.type === "CLOTH")
            return `/images/costumes/${size}/${item.preview_loc}`;            
        else if (item.type === "COMPANION" || item.type === "DIGGING-COMP")
            return `/images/companions/${size}/${item.preview_loc}`;
        else if (item.type === "WINGS")
            return `/images/wings/${size}/${item.preview_loc}`;
        else if (item.type === "BACKPACK")
            return `/images/backpacks/${size}/${item.preview_loc}`;
        else if (item.type === "GLASSES")
            return `/images/glasses/${size}/${item.preview_loc}`;
        else if (item.type === "CRAFTING")
            return `/images/crafting/${size}/${item.preview_loc}`;
        else if (item.type === "JUNK")
            return `/images/basics/${size}/${item.preview_loc}`;
        else if (item.type === "POTION")
            return `/images/potions/${size}/${item.preview_loc}`;
        else if (item.type === "ROD" || item.type === "FISH-BAIT")
            return `/images/rods/${size}/${item.preview_loc}`;
        else if (item.type === "EXTRA" || item.type === "EXTRAS")
            return `/images/extras/${size}/${item.preview_loc}`;
        else
            return `/images/${item.type.toLowerCase()}/${size}/${item.preview_loc}`;
    },
    nameForRarity(rarity) {
        switch (rarity) {
            case 1:case 0:
                return "Common";
            case 2:
                return "Rare";
            case 3:
                return "Unique";
            case 4:
                return "Legendary";
            case 5:
                return "Legendary +";
            default:
                return "Legendary ++";
        }
    },
    classForRarity(rarity) {
        switch (rarity) {
            case 1:case 0:
                return "";
            case 2:
                return "rare";
            case 3:
                return "unique";
            default:
                return "legendary";
        }
    },
    allowedCharsPress: function($event) {
        if ($event.key && !$event.key.match(/^\w+$/)) {
            $event.preventDefault();
        }
    },
    allowedRoomCharsPress: function ($event) {
        if ($event.key && !$event.key.match(/^[\w -]+$/)) {
            $event.preventDefault();
        }
    },
    transferNames: {
        'user_run': "a",
        'user_walk': "b"
    },
    prettyNumber(n) {
        if (isNaN(n))
            return n;

        if (n)
            return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        else
            return 0;
    },
    distanceBetweenTwoPoints: function (x1, y1, x2, y2) {
        var a = x1 - x2
        var b = y1 - y2

        var c = Math.sqrt(a * a + b * b);
        return c;
    },
    shuffleArray: function(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }
}